<script setup lang="ts">
import Mockup from '../Mockup.vue'
const { t } = useI18n()
const props = defineProps<{ module: string }>()
const { send } = useEvent()

const screenshotUrl = computed(() => {
  return `${import.meta.env.VITE_AWS_STORAGE_URL}/screenshots/`
})

const numberOfSteps = computed(() => {
  switch (props.module) {
    case 'contests':
      return 3
    default:
      return 1
  }
})

const isModalOpen = ref(false)

const openModal = () => {
  isModalOpen.value = true
  send('segment', `${props.module}.preview:detail:clicked`)
}

const emit = defineEmits<{ (e: 'openTemplatesTips'): void }>()
</script>

<template>
  <div class="relative h-screen">
    <div
      class="mx-auto flex w-full flex-col items-center justify-center gap-10 p-6 md:absolute md:top-1/2 md:-translate-y-2/4 md:px-12 xl:flex-row xl:items-stretch xl:gap-20"
    >
      <div class="flex items-center justify-center">
        <div>
          <h2 class="text-2xl font-extrabold text-foreground sm:text-3xl">
            {{ t(`accessDenied.title.${module}`) }}
          </h2>
          <p class="text-md mb-4 mt-1 font-light text-foreground-secondary sm:text-lg">
            {{ t(`accessDenied.subtitle.${module}`) }}
          </p>
          <div class="rounded-md bg-muted p-6">
            <p class="mb-4 font-extrabold text-foreground">{{ t('accessDenied.how') }}</p>
            <ol class="flex flex-col gap-4">
              <li
                v-for="step in numberOfSteps"
                :key="step"
                class="flex max-w-2xl items-center gap-4 text-sm text-foreground"
              >
                <BaseChip color="yellow" icon="HeroPlayIconSolid" :text="step" />
                {{ t(`accessDenied.steps.${module}.${step}`) }}
              </li>
            </ol>
          </div>
          <div class="mt-10 flex flex-col items-center gap-4 sm:flex-row">
            <Button variant="default-primary" @click="emit('openTemplatesTips')">
              {{ t(`accessDenied.buttons.${module}.primary`) }}
            </Button>
            <div class="flex cursor-pointer items-center gap-2 text-sm font-semibold text-primary" @click="openModal">
              <BaseIcon name="HeroPlayIconSolid" class="aspect-square w-5" />
              <span class="leading-4 underline"> {{ t(`accessDenied.buttons.${module}.secondary`) }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="mx-auto flex-1 xl:mx-0 2xl:max-w-md">
        <img :src="`${screenshotUrl}${module}.png`" :alt="module" class="h-full object-contain" />
      </div>
      <BaseModal :is-open="isModalOpen" size="md" @close="isModalOpen = false">
        <BaseIcon
          name="HeroXMarkIconSolid"
          class="fixed right-10 top-10 w-7 cursor-pointer text-white"
          @click="isModalOpen = false"
        />
        <Mockup type="mobile">
          <div
            ref="container"
            class="flex h-full w-full flex-col justify-start overflow-y-scroll rounded-lg bg-primary/10"
          >
            <img :src="`${screenshotUrl}${module}-demo.gif`" :alt="module" />
          </div>
        </Mockup>
      </BaseModal>
    </div>
  </div>
</template>
